export default __webpack_public_path__ + "images/0x09090e22118b375f2c7b95420c04414e4bf68e1a.png";